module.exports = "<div>Pro vyhledání parcely katastru nemovitostí podle pozice klikněte do mapového okna</div>\n"